import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';
import ButtonWithArrow from 'shared-components/buttons/button-with-arrow';

export class ReminderModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = { analyticsCalled: false };
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleBackBtn = this.handleBackBtn.bind(this);
  }

  componentDidUpdate () {
    if (!this.state.analyticsCalled) {
      const { whichModal = '' } = this.props;
      if (whichModal && whichModal !== 'ReminderModal') return;
      this.props.calendarSurveyAnalytics('do you want a reminder');
      this.setState({ analyticsCalled: true });
    }
  }

  handleButtonClick (currentChoice) {
    const { updateCalendarSyncReminder, toggleModal } = this.props;
    updateCalendarSyncReminder({ reminder_frequency: currentChoice }, ()=> {
      if ('Never' === currentChoice) {
        return toggleModal('SurveyCompleteModal');
      }
      toggleModal('NotificationChoiceModal');
    }
    );
  }

  handleBackBtn() {
    const { toggleModal, whichModalCb } = this.props;
    if (whichModalCb.backRoute) {
      return toggleModal(whichModalCb.backRoute);
    }
    toggleModal('WhyCantSyncModal');
  }

  render () {
    const { showModal, toggleModal } = this.props;
    return (
      <BootstrapModal
        showModal={showModal}
        toggleModal={toggleModal}
        modalClass="host-survey-modal"
        headerClass="modal-header"
        header={
          <div>
            <h3>
              <FormattedMessage
                id="shared.want_a_reminder.header"
                defaultMessage="Want a reminder to manually block your calendar?"
              />
            </h3>
            <p className="margin-lg-top">
              <FormattedMessage
                id="shared.want_a_reminder.header_text"
                defaultMessage="If you can’t sync a calendar, manually blocking is a great way to keep your availability updated on Peerspace and receive more bookings."
              />
            </p>
          </div>
        }
        body={
          <div className="margin-xl-bottom">
            <ButtonWithArrow
              text={<FormattedMessage
                id="shared.weekly_reminder.btn_text"
                defaultMessage="Yes, remind me weekly"
              />}
              onClick={()=>this.handleButtonClick('Weekly')}
            />
            <ButtonWithArrow
              text={<FormattedMessage
                id="shared.monthly_reminder.btn_text"
                defaultMessage="Yes, remind me monthly"
              />}
              className="margin-lg-top"
              onClick={()=>this.handleButtonClick('Monthly')}
            />
            <ButtonWithArrow
              text={<FormattedMessage
                id="shared.dont_know_how_to_import.btn_text"
                defaultMessage="No, I don't want reminders"
              />}
              className="margin-lg-top"
              onClick={()=>this.handleButtonClick('Never')}
            />
          </div>
        }
        bodyClass="sync-modal-body text-center"
      />
    );
  }
}

ReminderModal.propTypes = {
  showModal: PropTypes.bool,
  updateSurveyState: PropTypes.func,
  toggleModal: PropTypes.func,
  changeModal: PropTypes.func
};
